import React, { Component } from 'react';
import { Grid, Snackbar } from '@material-ui/core';
import LocationEditor from '../components/Settings/Location/LocationEditor';
import OriginEditor from '../components/Settings/OriginEditor';
import AttributeEditor from '../components/Settings/AttributeEditor';
import SpecialProjectsEditor from '../components/Settings/SpecialProjectsEditor';
import AgencyEditor from '../components/Settings/AgencyEditor';
import AgentEditor from '../components/Settings/AgentEditor';

import '../assets/stylesheets/Setting.css';

class EntityManagementView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      snackbarOpen: false,
      snackbarMessage: '',
      agencies: [],
    };

    this.agentEditorRef = React.createRef();
  }

  closeSnackbar = () => {
    this.setState({ snackbarOpen: false, snackbarMessage: '' });
  };

  openSnackbar = message => {
    this.setState({ snackbarMessage: message, snackbarOpen: true });
  };

  updateAgencies = agencies => {
    this.setState({ agencies }, () => {
      if (this.agentEditorRef.current) {
        this.agentEditorRef.current.getAgents();
      }
    });
  };

  render() {
    const {
      agencies,
      snackbarMessage,
      snackbarOpen,
    } = this.state;

    return (
      <>
        <Grid container className="settingsView">
          <LocationEditor />
          <OriginEditor openSnackbar={this.openSnackbar} />
          <AgencyEditor
            openSnackbar={this.openSnackbar}
            updateAgencies={this.updateAgencies}
          />
          <AgentEditor
            ref={this.agentEditorRef}
            openSnackbar={this.openSnackbar}
            agencies={agencies}
          />
          <AttributeEditor
            openSnackbar={this.openSnackbar}
          />
          <SpecialProjectsEditor openSnackbar={this.openSnackbar} />
        </Grid>
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={this.closeSnackbar}
          autoHideDuration={2000}
        />
      </>
    );
  }
}

export default EntityManagementView;
